import { useCallback, useState } from 'react'
import { useAgentRuntime, useAgentStore } from '@/context/AgentProvider'
import { getGuestUserId } from '@/utils/guestUserId'

export const useDeleteChat = () => {
  const runtime = useAgentRuntime()
  const userId = runtime.config.user?.id ?? getGuestUserId()
  const activeChatId = useAgentStore((state) => state.activeChatId)
  const removeChat = useAgentStore((state) => state.removeChat)
  const setActiveChat = useAgentStore((state) => state.setActiveChat)

  const [deletingChatIds, setDeletingChatIds] = useState<Set<string>>(new Set())

  const deleteChat = useCallback(
    async (chatId: string) => {
      setDeletingChatIds((prev) => new Set(prev).add(chatId))
      try {
        await runtime.transport.deleteChat(chatId)
        removeChat(chatId)
        if (activeChatId === chatId) {
          setActiveChat(undefined)
        }
        runtime.queryClient.invalidateQueries({ queryKey: ['mp-agents', 'chats', userId] })
      } finally {
        setDeletingChatIds((prev) => {
          const next = new Set(prev)
          next.delete(chatId)
          return next
        })
      }
    },
    [activeChatId, removeChat, runtime.queryClient, runtime.transport, setActiveChat, userId]
  )

  const isDeleting = useCallback((chatId: string) => deletingChatIds.has(chatId), [deletingChatIds])

  return { deleteChat, isDeleting }
}

export default useDeleteChat
